const CHALLENGE_KEY = 'auth.deviceChallenge'
const DEVICES_KEY = 'auth.trustedDevices'
const TOKEN = /^[a-f0-9]{64}$/

function read(storage, key, fallback) {
  try { return JSON.parse(storage.getItem(key)) || fallback } catch (error) { return fallback }
}

export function getDeviceToken(email) {
  const devices = read(window.localStorage, DEVICES_KEY, [])
  if (!Array.isArray(devices)) return undefined
  const device = devices.find(item => item && item.email === String(email).trim().toLowerCase()
    && TOKEN.test(item.token) && Date.parse(item.expiresAt) > Date.now())
  return device ? device.token : undefined
}

export function rememberDevice(session) {
  if (!session || !session.user || !TOKEN.test(session.deviceToken) || !(Date.parse(session.deviceExpiresAt) > Date.now())) return
  const email = session.user.email
  const stored = read(window.localStorage, DEVICES_KEY, [])
  const devices = (Array.isArray(stored) ? stored : []).filter(item => item && item.email !== email && Date.parse(item.expiresAt) > Date.now())
  devices.push({ email, token: session.deviceToken, expiresAt: session.deviceExpiresAt })
  try { window.localStorage.setItem(DEVICES_KEY, JSON.stringify(devices.slice(-10))) } catch (error) { /* storage unavailable */ }
}

export function saveDeviceChallenge(challenge, redirectFrom) {
  const value = { ...challenge, redirectFrom }
  window.sessionStorage.setItem(CHALLENGE_KEY, JSON.stringify(value))
  return value
}

export function getDeviceChallenge() {
  const challenge = read(window.sessionStorage, CHALLENGE_KEY, null)
  return challenge && TOKEN.test(challenge.challengeId) && Date.parse(challenge.expiresAt) > Date.now() ? challenge : null
}

export function clearDeviceChallenge() {
  window.sessionStorage.removeItem(CHALLENGE_KEY)
}
